module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user/admin/shared/admin-form/admin-form.component.html
// module id = ./src/app/user/admin/shared/admin-form/admin-form.component.html
// module chunks = main